import Layout from '@/apps/layout/components'
import UrbanClub from '@/apps/UrbanClub'
import React from 'react'

const UrbanClubPage = (): React.ReactElement => {
  return (
    <Layout>
      <UrbanClub />
    </Layout>
  )
}

export default UrbanClubPage
